import axios from "axios"

let BASE_URL: string
if (process.env.NODE_ENV === "production") {
  BASE_URL = "https://us-central1-runbit-ddf6c.cloudfunctions.net"
} else {
  BASE_URL = `//${window.location.host}/api/runbit-ddf6c/us-central1`
}

export function addOrganizationMember(organization: string, idToken: string) {
  return axios.put(
    `${BASE_URL}/organizations/${organization}/member`,
    {},
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    }
  )
}

export function addOrganizationMemberByEmail(
  organization: string,
  email: string,
  idToken: string
) {
  return axios.put(
    `${BASE_URL}/organizations/${organization}/${email}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    }
  )
}

interface AddResponse {
  status: "OK"
  existingUser: boolean
}
export function forceAddOrganizationMember(
  organization: string,
  email: string
) {
  return axios
    .put<AddResponse>(
      `${BASE_URL}/organizations/${organization}/${email}/force`,
      {}
    )
    .then(res => res.data)
}

export function createOrganization(orgName: string, idToken: string) {
  return axios
    .put<string>(
      `${BASE_URL}/createOrganizationWeb/`,
      {
        orgName,
      },
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }
    )
    .then(res => res.data)
}

export function hasPaid(idToken: string) {
  return axios.get(`${BASE_URL}/payment/hasPaid`, {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  })
}

interface PaymentStatus {
  paid: "paid" | "free" | "no"
  until?: 12393939934
  from?: {
    name: "Järla skola"
    image: "http://google.png"
  }
}

export function paymentStatus(idToken: string) {
  return axios
    .get<PaymentStatus>(`${BASE_URL}/paymentStatus`, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    })
    .then(res => res.data)
}

export interface GroupInfo {
  id: string
  created: number
  icon: string
  inviteLink: string
  name: string
  members: {
    email: string
    id: string
  }[]
}

export interface MyOrganizationsResponse {
  canCreateOrganizations: boolean
  groups: GroupInfo[]
}

export function myOrganizations(idToken: string) {
  return axios
    .get<MyOrganizationsResponse>(`${BASE_URL}/myOrganizations`, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    })
    .then(res => res.data)
}

export function deleteGroupMember(
  idToken: string,
  groupId: string,
  email: string
) {
  return axios.delete(`${BASE_URL}/organizations/${groupId}/${email}`, {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  })
}

interface EmailOptions {
  subject: string
  name: string
  message: string
  phone: string
  email: string
}
export function sendMail({
  subject,
  name,
  message,
  phone,
  email,
}: EmailOptions) {
  return axios.post(`${BASE_URL}/sendMail`, {
    subject,
    name,
    message,
    phone,
    email,
  })
}

export interface CreatedGroup {
  created: number
  name: string
  memberCount: number
  inviteLink: string
  payment: unknown
}

export async function createGroup(
  name: string,
  idToken: string
): Promise<{ key: string; value: CreatedGroup }> {
  const res = await axios.post(
    `${BASE_URL}/createGroup`,
    { name },
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    }
  )
  return res.data
}

export async function offerUse(
  offerId: string,
  idToken: string
): Promise<string> {
  const res = await axios.post(
    `${BASE_URL}/handleOffer/use`,
    { offerId },
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    }
  )
  return res.data
}

export async function registerInvoice(
  groupId: string,
  data: Record<string, string>
): Promise<{ status: number; data: string | { errors: string[] } }> {
  const res = await axios.post(
    `${BASE_URL}/invoice/register`,
    {
      groupId,
      data,
    },
    {
      responseType: "text",
      validateStatus: status => status >= 200 || status === 400,
    }
  )

  return { status: res.status, data: res.data }
}

export async function registerInvoiceOrganization(
  organizationName: string,
  contactEmail: string,
  data: Record<string, string>
): Promise<{ status: number; data: string | { errors: string[] } }> {
  const res = await axios.post(
    `${BASE_URL}/invoice/register-organization`,
    {
      organizationName,
      contactEmail,
      data,
    },
    {
      responseType: "text",
      validateStatus: status => status === 200,
    }
  )

  return { status: res.status, data: res.data }
}
